import { IRectangle, List } from "@fluentui/react";
import { ContextualMenuItem } from "../../home/models/OtherTypes";
import { HomePageLinkType } from "../../products/models/ProductModel";

type BrandGridProps = {
    brands: ContextualMenuItem[];
}

export default function BrandGridView({ brands }: BrandGridProps) {
    var columnCount: number = 2;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            let count = 2;

            const width = surfaceRect?.width ?? 0;
            count = Math.trunc(width / 220);

            if (count < 2) count = 2;

            columnCount = count;
        }

        return brands.length;
    }

    const onSelect = (brand: ContextualMenuItem) => {
        window.open(`/products?type=${HomePageLinkType.quickLink}&&key=${brand.key}`, "_self");
    }

    const onRenderCell = (brand?: ContextualMenuItem, index?: number, isScrolling?: boolean) => {
        if (!brand) {
            return <div></div>;
        }

        const width = (100 / columnCount) + '%';

        return <div key={brand.id} className="list-grid-tile p-10" style={{ width: width }}>
            <a onClick={() => onSelect(brand)}>
                <div className={"box pv-10 center"}>
                    {brand.text}
                </div>
            </a>
        </div>;
    }

    return <div>
        <List
            key={columnCount}
            items={brands}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage} />
    </div>;
}